// extracted by mini-css-extract-plugin
export default {"footerComponent":"Footer_footerComponent__UEDuv","footerContainer":"Footer_footerContainer__Yu8E2","lastFoot":"Footer_lastFoot__Ditpg"};